module.exports = __webpack_public_path__ + "img/music-school-icon2.367c97f1.png";